<template>
  <div>
    {{ ActDescBtn }}
    <table style="position: absolute" width="100%" :height="this.windowSize.height - 8"
      :max-height="this.windowSize.height - 8">
      <tr max-height="48px" height="48px">
        <ContenidoBase :titulo="'Precio Producto'" :descripcion="'Ver Precio de los Productos'" :EstadoBtn="EstadoBtn"
          @abrirBarraTablaDinamica="abrirTabla" @MethodNuevo="newwnuevo" @MethodGuardar="save" @MethodEliminar="remove"
          @MethodAnular="anular" @MethodImprimir="imprimirList" />
      </tr>

      <tr>
        <!-- BarraPrimaria 96 --------------------------------------------------------------------------------->
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraTablaDinamicaAprir">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <center>
                  <!-- <v-btn-toggle></v-btn-toggle> -->
                  <v-btn small width="95%" color="yellow accent-4" @click.prevent="actualiza_tb_ver">
                    <i style="font-size: 25px" class="fa fa-eye"> </i>
                    ver</v-btn>
                </center>
              </template>
            </v-tooltip>
          </div>
        </td>
        <!-- fn BarraPrimaria ---------------------------------------------------------------------------------->
        <!-- contenido central ------------------------------------------------------------------------------ -->
        <td :max-height="this.windowSize.height - 96">
          <v-app id="inspire" class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }">
            <!-- Formulario-Ver precio producto -->
            <v-container fluid>
              <div @click="ver">
                <!--style="display:none;"  -->
                <v-row>

                  <v-expand-transition>
                    <v-col cols="3" v-show="mostrarEspeciales" id="especiales">
                      <h2 style="color: white;">ESPECIALES</h2>
                      <v-list dense v-for="especial in this.especiales" :key="especial.codigo" class="mb-2">
                        <div class="pl-3">
                          <p class="mb-1"><b>{{ especial.porciento }}%</b></p>
                          <p class="mb-1">Valido hasta {{ especial.fechafin }}</p>
                        </div>
                      </v-list>
                    </v-col>
                  </v-expand-transition>

                  <v-col>
                    <!-- fila 1 ------------------------------>
                    <v-col cols="12" md="12">
                      <v-row :align="'center'" :justify="'center'">
                        <!-- <i style="font-size: 20px;" class="fa fa-font">ok</i> -->

                        <img @load="ver" height="232" width="232" :src="logo" alt="micromarket" />
                      </v-row>
                    </v-col>
                    <!-- fn fila 1 ------------------------------>

                    <!-- fila 2 ------------------------------>
                    <v-col cols="12" md="12" class="pa-0 ma-0 py-0 my-0">
                      <v-row :align="'center'" :justify="'center'">
                        <b><i style="font-size: 36px">{{ usuario }}</i></b>
                      </v-row>
                    </v-col>

                    <v-col cols="12" md="12" class="pa-0 ma-0 py-0 my-0" >
                      <v-row :align="'center'" :justify="'center'">
                        <b><i style="font-size: 36px">{{ productoDescripcion }}</i></b>
                      </v-row>
                    </v-col>
                    <!-- fn fila2 -------------------------->

                    <!-- fila 2 ------------------------------>
                    <v-col cols="12" md="12" class="pa-0 ma-0 py-0 my-0">
                      <v-row :align="'center'" :justify="'center'">
                        <b  style="font-size: 75px ">RD$.{{ currencyFormatter(precio) }}</b>
                      </v-row>
                    </v-col>
                    <!-- fn fila2        -------------------------->
                  </v-col>

                  <v-expand-transition>
                    <v-col cols="3" v-show="mostrarOfertas" id="ofertas">
                      <h2 style="color: white;">OFERTAS</h2>
                      <v-list dense v-for="oferta in this.ofertas" :key="oferta.codigo" class="mb-2">
                        <div class="pl-3" v-for="detalle in oferta.ofertaDetalleList" :key="detalle.id">
                          <p class="mb-1">Por la compra de <b>{{ oferta.producto.descripcion }}</b> te llevas <b> {{
                            detalle.cantidad }} {{
                                detalle.producto.descripcion }} </b></p>
                          <p class="mb-1">Valido hasta {{ oferta.fechafinal }}</p>
                        </div>
                      </v-list>
                    </v-col>
                  </v-expand-transition>
                </v-row>

                <center>
                  <!-- <v-form ref="form" v-model="valid" lazy-validation> </v-form>  -->
                  <v-text-field style="font-size: 0px" :autofocus="true" id="codigo" color="white" type="text"
                    inputmode="none" autocomplete="off" v-model="producto.codigo" @blur="mantenerFoco"
                    @mousedown.prevent @touchstart.prevent @input="leerCodigoInput" @change="ejecutar">
                  </v-text-field>
                </center>
              </div>
            </v-container>
            <!-- Formulario-Ver precio producto -->

          </v-app>
        </td>
        <!-- fn contenido central ------------------------------------------------------------------------------------->
        <!-- BarraSecundaria ------------------------------------------------------------------------------------------>
        <td width="109" :max-height="this.windowSize.height - 96" v-show="BarraSecundariaAprir">
          <div class="overflow-y-auto" v-bind:style="{
            'max-height': this.windowSize.height - 96 + 'px',
            'max-width': '325px',
            width: '325px',
          }"></div>
        </td>
        <!-- fn BarraSecundaria --------------------------------------------------------------------------------------->
      </tr>
    </table>
  </div>
</template>

<script>
//  var valor = '';
//             $(document).keydown(function (e) {
//                 valor += e.key;
//                 if (e.keyCode === 13) {
//                     valor.substring(0, valor.length - 5);
//                     leerPro(valor);
//                     valor = '';
//                 }
//             });
//             leerPro = function (valor) {
//                 console.log(valor.substring(0, valor.length - 5));
//                 leer_pro(valor.substring(0, valor.length - 5));
//             };
//             window.onload = function () {
//                 function foo() {
//                     alert("test");
//                 }
//                 setInterval(foo, 500);

import VueAutonumeric from "../../components/VueAutonumeric";
import { EventBus } from "../../event-bus";
import ContenidoBase from "../../components/ContenidoBase";

export default {
  components: {
    VueAutonumeric,
    ContenidoBase,
  },

  directives: {
    dirkeydown: {
      // Definición de directiva
      bind(el, binding) {
        // __HandleScrollHandler__
        el.__HandledKey__ = event => binding.value(event)
        document.body.addEventListener('keydown', el.__HandledKey__)
      },
      unbind(el) {
        document.body.removeEventListener('keydown', el.__HandledKey__)
      }

    }
  },

  created() {
    var json = {
      titulo: "Precio Producto",
      descripcion: "Ver Precio de los Productos",
      save: false,
      eliminar: false,
      anular: false,
      nuevo: false,
      imprimir: false,
      btnBarraDi: false,
    };
    EventBus.$emit("anularBotonesAccion", json);
  },

  //mounted-carga de inicio
  mounted() {
    this.cargarDatos();
    window.addEventListener("keydown", this.leerCodigoLector, true);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.leerCodigoLector, true);
    clearTimeout(this.scannerTimer);
  },
  //mounted-carga de inicio

  methods: {
    abrirTabla() {
      this.BarraTablaDinamicaAprir = !this.BarraTablaDinamicaAprir;
    },

    // llama a una api y trae los datos unidad producto.
    ejecutar() {
      this.ejecutarCodigo(this.producto.codigo);
    },

    ejecutarCodigo(codigo) {
      codigo = (codigo || "").toString().trim();
      console.log(codigo);

      if (!codigo) {
        return;
      }

      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          "/unidades-productos/" +
          codigo +
          "/" +
          false +
          "/buscar"
        )
        .then((res) => {
          if (!res.data || res.data.length === 0) {
            this.precio = 0
            this.descripcion = "Producto no encontrado"
            this.productoDescripcion = ""
            this.ofertas = []
            this.especiales = []
            return
          }

          const unidadProducto = res.data[0]
          this.findOfertasProducto(unidadProducto.productos.codigo)
          this.findEspecialesProducto(unidadProducto.productos.codigo)
          this.precio = unidadProducto.precio || 0
          this.descripcion = unidadProducto.productos.descripcion
          this.productoDescripcion = unidadProducto.productos.descripcion
        })
        .catch(() => {
          this.precio = 0
          this.descripcion = "No se pudo consultar el producto"
          this.productoDescripcion = ""
          this.ofertas = []
          this.especiales = []
        })
        .finally(() => {
          this.mantenerFoco()
        });

      this.producto.codigo = "";
      setTimeout(this.limpiar, 15000);
    },

    leerCodigoLector(event) {
      if (event.ctrlKey || event.altKey || event.metaKey) {
        return;
      }

      if (event.key === "Enter") {
        event.preventDefault();
        event.stopPropagation();
        this.ejecutarBufferLector();
        this.mantenerFoco();
        return;
      }

      if (event.key && event.key.length === 1) {
        event.preventDefault();
        event.stopPropagation();
        clearTimeout(this.scannerTimer);
        this.scannerBuffer += event.key;
        this.producto.codigo = this.scannerBuffer;
        this.scannerTimer = setTimeout(this.ejecutarBufferLector, this.scannerDelay);
      }
    },

    leerCodigoInput(valor) {
      clearTimeout(this.scannerTimer);
      this.scannerBuffer = (valor || "").toString();
      this.scannerTimer = setTimeout(this.ejecutarBufferLector, this.scannerDelay);
    },

    ejecutarBufferLector() {
      clearTimeout(this.scannerTimer);
      const codigo = this.scannerBuffer.trim();
      this.scannerBuffer = "";
      this.producto.codigo = "";
      if (codigo) {
        this.ejecutarCodigo(codigo);
      }
    },

    findEspecialesProducto(codigo) {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          `/especiales/findEspecialesByCodigoProducto/${codigo}`
        )
        .then((res) => {
          this.especiales = res.data
        });
    },

    findOfertasProducto(codigo) {
      this.$axios
        .get(
          this.$hostname +
          this.$hName +
          `/ofertas/findOfertasByCodigoProducto/${codigo}`
        )
        .then((res) => {
          this.ofertas = res.data
        });
    },

    // reestablece  los datos.
    limpiar() {
      this.precio = 0;
      this.descripcion = "";
      this.productoDescripcion = "";
      this.ofertas = [];
      this.especiales = []
    },

    mantenerFoco() {
      //console.log('ok')
      setTimeout(() => {
        const codigo = document.getElementById("codigo");
        if (codigo) {
          codigo.focus({ preventScroll: true });
        }
      }, 50);
    },

    ver() {
      this.mantenerFoco();
      const app = document.getElementById('inspire')
      if (app && app.requestFullscreen && !document.fullscreenElement) {
        app.requestFullscreen().catch(() => {})
      }
    },

    currencyFormatter(params) {
      //return this.formatNumber(params) + ".00";
      return this.formatNumber(params);
    },

    formatNumber(number) {
      // return Math.floor(number)
      //   .toString()
      //   .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

      return Number(number || 0)
        .toFixed(2)
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },

    save() { },
    remove() { },
    anular() { },
    imprimir() { },
    nuevo() { },
    newwnuevo() { },
    imprimirList() { },
    cargarDatos() {
      this.configuraciones = this.$store.getters.GetConfiguracionGeneral;
      this.usuario = this.configuraciones.config.nombre;
      this.logo = this.configuraciones.config.logo;
    },
  },

  data() {
    return {
      windowSize: { width: "auto", height: "auto" },
      valid: true,
      BarraTablaDinamicaAprir: false,
      BarraSecundariaAprir: false,
      Rdata: [],
      usuario: "FARMACIA BIBBIA",
      precio: 0,
      descripcion: "",
      productoDescripcion: "",
      logo: "",
      configuraciones: null,
      producto: {
        codigo: "",
      },
      scannerBuffer: "",
      scannerTimer: null,
      scannerDelay: 800,
      especiales: [],
      ofertas: [],

      EstadoBtn: {
        BarraTablaDinamicaAprir: false,
        nuevo: false,
        guardar: false,
        eliminar: false,
        anular: false,
        imprimir: false,
        vercuenta: false,
        guardartemporal: false,
        restaurartemporal: false,
        importarDato: false,
        cargarProducto: false,
        ImprimirproductoInv: false,
      },

      rules: {
        required: (value) => !!value || "Required.",
        edad: [
          (val) => val > 10 || `Edad debe ser mayor a 10`,
          (val) => val < 70 || `Edad debe ser menor a 120`,
        ],
        counter: (value) =>
          (value && value.length <= 50) || "Max 20 characters",
        RTel: (value) => value != 10 || `telefono debe tener 10 digitos`,
        // email: value => {
        //   const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        //   return pattern.test(value) || 'Invalid e-mail.'
        // },
      },
    };
  },
  computed: {
    ActDescBtn() {
      this.windowSize = JSON.parse(
        JSON.stringify(this.$store.getters.GetwindowSize)
      );
    },
    mostrarEspeciales() {
      return this.especiales.length > 0 ? true : false
    },
    mostrarOfertas() {
      return this.ofertas.length > 0 ? true : false
    },
  },
};
</script>

<style>
#especiales,
#ofertas {
  background-color: #DD4B39;
  border-radius: 3%;
}
</style>
